class MoreProducts {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    var page = 2; //初期ページ番号
    $("." + this.el).on('click', function (e) {
      e.preventDefault();
      let treeType = $(this).attr('data-cat');
      let productsSize = $(this).attr('data-size');
      let productsPrice = $(this).attr('data-price');
      let productsCat = $(this).attr('data-pcat');
      let productsWords = $(this).attr('data-words');
      $.ajax({
        url: ajaxurl,
        type: 'GET',
        data: {
          action: 'load_more_products',
          page: page,
          treeType: treeType,
          productsSize: productsSize,
          productsPrice: productsPrice,
          productsCat: productsCat,
          productsWords: productsWords,
        },
        success: function (response) {
          var data = JSON.parse(response);
            $('.js-more-products-contents').append('<div style="display:none;" class="new-posts">' + data.content + '</div>');
            $('.new-posts').fadeIn('slow');
          if (!data.hasMorePosts) {
              $('.js-more-products').fadeOut();
          } else {
              page++;
          }
        }
      });
    });
  }
}